import invariant from 'invariant';

import { LocationField } from 'components/Form/LocationField';

type Props = {
  values: {
    salaryBasedOn?: string;
    remoteStatus?: string;
    workCityStateUnified?: string;
  };
  handlePlaceDetails?: (
    place: google.maps.GeocoderResult,
    isEmployer: boolean,
  ) => void;
  updateValueWith?: (
    arg0: string | string[],
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    arg1: (arg0: Record<string, any>) => unknown,
  ) => void;
};

export function WorkCityStateUnified({
  values,
  handlePlaceDetails,
  updateValueWith,
}: Props) {
  let label;
  if (values.remoteStatus === 'ONSITE') {
    label = `${getText('Location')}*`;
  } else if (values.salaryBasedOn === 'EMPLOYER_LOCATION') {
    label = `${getText('Select the location where the work was performed')}`;
  } else if (values.salaryBasedOn === 'OWN_LOCATION') {
    label = `${getText('Select the location where the work was performed')}*`;
  }
  invariant(label, 'Label has no value');

  return (
    <LocationField
      name="workCityStateUnified"
      addressTypes={['(cities)']}
      handlePlaceDetails={(place) => {
        // @ts-expect-error TS(2722): Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
        handlePlaceDetails(place, false);
      }}
      label={label}
      noWrap
      placeholder={getText('e.g. Hawkins, IN')}
      componentRestrictions={{
        country: 'US',
      }}
      customErrorMatch={(errors) => errors.workStateCode}
      locationText={values.workCityStateUnified}
      onClear={() =>
        // @ts-expect-error TS(2722): Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
        updateValueWith(
          ['workCity', 'workStateCode', 'workLatitude', 'workLongitude'],
          () => ({
            workCity: null,
            workStateCode: null,
            workLatitude: null,
            workLongitude: null,
          }),
        )
      }
    />
  );
}
